import React from 'react'

import * as s from './textinput.module.css'

interface TextInputProps {
    name?: string,
    type?: string,
    placeholder?: string,
    width?: number,
    onChange: (value: any) => void
}

export const TextInput: React.FC<TextInputProps> = ({
    placeholder,
    width = 160,
    onChange,
    type = 'text',
    name,
}) => {

    return <div className={s.container} >
    <input
        className={`fs-18px ${s.input}`}
        placeholder={placeholder}
        onChange={value => onChange(value)}
        type={ type }
        name={ name }
    />
        <span className={s.line}    />
    </div>
}